import {PartialFrameElements} from '../type/PartialFrameElements.interface';
import {TextViewerCoreOption} from '../type/TextViewerCoreOption.type';

/**
 * 컨텐츠 내 요소에 인라인 스타일을 적용하는 함수
 *
 * Readium을 참고해서 스타일을 적용했습니다.
 * https://github.com/readium/readium-shared-js/blob/0d275107f553e8ac088b02689965525de4cccb4a/js/helpers.js#L313-L388
 *
 * frameElements가 DOM에 붙은 이후에 불러야합니다.
 */
export function applyContentInlineStyles({
  frameElements,
  option,
}: {
  frameElements: PartialFrameElements;
  option: TextViewerCoreOption;
}) {
  const {contentElement} = frameElements;
  const {fontSizePercent, lineHeight} = option;

  const fontSizeFactor = fontSizePercent / 100;

  const textBlockNodeList = contentElement.querySelectorAll<HTMLElement>(
    'p, div, span, h1, h2, h3, h4, h5, h6, li, blockquote, td, pre, dt, dd, code, a'
  );

  for (const element of textBlockNodeList) {
    const fontSizeAttribute = element.getAttribute('data-original-font-size');
    if (fontSizeAttribute) {
      break;
    }

    const computedStyle = window.getComputedStyle(element);
    const originalFontSize = parseInt(computedStyle.fontSize);
    element.setAttribute('data-original-font-size', String(originalFontSize));

    const originalLineHeight = parseInt(computedStyle.lineHeight);
    if (originalLineHeight) {
      element.setAttribute(
        'data-original-line-height',
        String(originalLineHeight)
      );
    }
  }

  for (const element of textBlockNodeList) {
    const fontSizeAttribute = element.getAttribute('data-original-font-size');
    const originalFontSize = fontSizeAttribute ? Number(fontSizeAttribute) : 0;
    if (originalFontSize) {
      element.style.setProperty(
        'font-size',
        `${originalFontSize * fontSizeFactor}px`,
        'important'
      );
    }

    /**
     * iOS의 epub 뷰어와 동일하게 값을 강제합니다.
     * 페이지 계산에 어떤 사이드이펙트가 날지 몰라 완전히 동일한 형태로 구현하지 않고 기존 구현을 활용합니다.
     * https://github.kakaocorp.com/kakaopage/ios/blob/develop/KaKaoPage/Classes/Viewer/BookViewer/Epub/Readium/ReadiumCSS-after.css#L554-L570 참고
     */
    if (
      element instanceof HTMLParagraphElement ||
      element instanceof HTMLDivElement ||
      element instanceof HTMLLIElement
    ) {
      element.style.setProperty('line-height', String(lineHeight), 'important');
    }
  }
}
